/* 
    This shows/hide alert bar 
    PHP code is in includes\modules\show-alert.php
*/
(function () {
    const bar = document.getElementById('site-alert-bar');
    if (!bar) return;

    const version = bar.dataset.version || '1';
    const cookieName = 'siteAlertDismissed';
    const dismissible = bar.dataset.dismissible === 'true' || bar.dataset.dismissible === true;


    // Get cookie
    const getCookie = (name) => {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    };

    // Set cookie (7 days)
    const setCookie = (name, value, days = 7) => {
        const date = new Date();
        date.setTime(date.getTime() + (days * 86400000));
        const expires = 'expires=' + date.toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/; SameSite=Lax`;
    };

    // Show only if not dismissed or if !dismissible
    const currentCookieVersion=getCookie(cookieName);
    if (!dismissible || currentCookieVersion !== version) {
        bar.style.display = 'block';
    }

    // On close, hide and store cookie
    document.getElementById('alert-close')?.addEventListener('click', function () {
        bar.remove(); // or use bar.style.display = 'none';
        setCookie(cookieName, version);
    });
})();
